import React, { useState, useEffect } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { DOCTOR_SPECIALIZATIONS, NURSE_SPECIALIZATIONS } from '../../constants/specializations';

const SERVICE_OPTIONS = [
  { value: 'clinic', label: 'Clinic Consultation' },
  { value: 'home_visit', label: 'Home Visit' },
  // { value: 'video', label: 'Video Consultation' }, // Coming soon
  // { value: 'emergency', label: 'Emergency Visit' },
];

export default function Step2Professional({ data = {}, onSave, userRole }) {
  const specList = userRole === 'nurse' ? NURSE_SPECIALIZATIONS : DOCTOR_SPECIALIZATIONS;
  const [form, setForm] = useState({
    role: userRole || 'doctor',
    medical_registration_number: '',
    primary_specialization: '',
    secondary_specialization: '',
    experience_years: '',
    consultation_languages: [],
    qualification: '',
    bio: '',
    services: ['clinic'],
    ...data,
  });

  useEffect(() => { if (data) setForm(prev => ({ ...prev, ...data })); }, [data]);
  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const toggleService = (val) => update('services', form.services.includes(val) ? form.services.filter(s => s !== val) : [...form.services, val]);

  return (
    <form id="step-form-2" onSubmit={(e) => { e.preventDefault(); onSave(form); }} className="p-6 lg:p-8 space-y-6">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Role</Label>
          <Input value={form.role} disabled className="mt-1.5 bg-slate-50 capitalize" data-testid="p2-role" />
        </div>
        <div>
          <Label>Medical Registration Number *</Label>
          <Input required value={form.medical_registration_number} onChange={(e) => update('medical_registration_number', e.target.value)} placeholder="MCI / State Council" className="mt-1.5" data-testid="p2-reg-no" />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Primary Specialization *</Label>
          <Select value={form.primary_specialization} onValueChange={(v) => update('primary_specialization', v)}>
            <SelectTrigger className="mt-1.5" data-testid="p2-primary-spec"><SelectValue placeholder="Select" /></SelectTrigger>
            <SelectContent className="max-h-72">{specList.map(s => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Secondary Specialization</Label>
          <Select value={form.secondary_specialization} onValueChange={(v) => update('secondary_specialization', v)}>
            <SelectTrigger className="mt-1.5" data-testid="p2-secondary-spec"><SelectValue placeholder="Optional" /></SelectTrigger>
            <SelectContent className="max-h-72"><SelectItem value="none">None</SelectItem>{specList.map(s => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Years of Experience *</Label>
          <Input required type="number" min={0} max={70} value={form.experience_years} onChange={(e) => update('experience_years', e.target.value)} placeholder="e.g. 5" className="mt-1.5" data-testid="p2-exp" />
        </div>
        <div>
          <Label>Highest Qualification *</Label>
          <Input required value={form.qualification} onChange={(e) => update('qualification', e.target.value)} placeholder="MBBS, MD, BDS, GNM etc." className="mt-1.5" data-testid="p2-qual" />
        </div>
      </div>

      <div>
        <Label>Professional Bio</Label>
        <Textarea rows={4} value={form.bio} onChange={(e) => update('bio', e.target.value)} placeholder="Describe your expertise, approach, and patient care philosophy" className="mt-1.5" data-testid="p2-bio" />
      </div>

      <div>
        <Label>Services Offered *</Label>
        <div className="grid sm:grid-cols-2 gap-3 mt-2">
          {SERVICE_OPTIONS.map(s => (
            <button
              type="button"
              key={s.value}
              onClick={() => toggleService(s.value)}
              className={`p-4 rounded-xl border-2 text-left transition-all ${
                form.services.includes(s.value) ? 'border-[#3B1C73] bg-[#3B1C73]/5 text-[#3B1C73]' : 'border-slate-200 hover:border-slate-300 text-slate-700'
              }`}
              data-testid={`p2-service-${s.value}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-semibold">{s.label}</span>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                  form.services.includes(s.value) ? 'border-[#3B1C73] bg-[#3B1C73]' : 'border-slate-300'
                }`}>
                  {form.services.includes(s.value) && <div className="w-2 h-2 bg-white rounded-full" />}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </form>
  );
}
